import { render, staticRenderFns } from "./lrCodeEditor.vue?vue&type=template&id=012b85e8&"
import script from "./lrCodeEditor.vue?vue&type=script&lang=js&"
export * from "./lrCodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./lrCodeEditor.vue?vue&type=style&index=0&id=012b85e8&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports